import React from 'react'

const TrashIcon = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.6562 3.28125H2.34375" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M6.09375 6.09375V9.84375" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M8.90625 6.09375V9.84375" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M11.7188 3.28125V12.1875C11.7188 12.3118 11.6694 12.431 11.5815 12.519C11.4935 12.6069 11.3743 12.6562 11.25 12.6562H3.75C3.62568 12.6562 3.50645 12.6069 3.41854 12.519C3.33064 12.431 3.28125 12.3118 3.28125 12.1875V3.28125" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9.84375 3.28125V2.34375C9.84375 2.09511 9.74498 1.85665 9.56916 1.68084C9.39335 1.50502 9.15489 1.40625 8.90625 1.40625H6.09375C5.84511 1.40625 5.60665 1.50502 5.43084 1.68084C5.25502 1.85665 5.15625 2.09511 5.15625 2.34375V3.28125" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default TrashIcon
